import { Block } from 'baseui/block';
import { ProgressBar } from 'baseui/progress-bar';
import { HeadingSmall, LabelMedium } from 'baseui/typography';
import { getMarginTagColor } from '@gtintel/platform-utils';
export const MarginProgressBar = ({
  projectMargin
}) => {
  const minValue = projectMargin < 0 ? projectMargin : 0;
  return <>
      <ProgressBar value={projectMargin} size="large" minValue={minValue} maxValue={1} overrides={{
      BarProgress: {
        style: {
          backgroundColor: getMarginTagColor(projectMargin)
        }
      }
    }} />
      <Block display="flex" alignItems="center" justifyContent="space-between" marginTop="scale300">
        <LabelMedium>0%</LabelMedium>
        <HeadingSmall margin="0">
          {(projectMargin * 100).toFixed(1)}%
        </HeadingSmall>
        <LabelMedium>100%</LabelMedium>
      </Block>
    </>;
};